// src/store/modules/entity.js

import axios from 'axios'
import { canAccessFeature } from '@/utils/access'
import { FEATURES } from '@/constants/features'

let pendingEntitiesRequest = null

export default {
  namespaced: true,
  state: () => ({
    current_entity_id:
      typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function' && localStorage.getItem('current_entity_id')
        ? Number(localStorage.getItem('current_entity_id'))
        : null,
    current_entity_name:'Unknown',
    availableEntities: [],
    hasRequestedEntities: false
  }),
  mutations: {
    SET_ENTITY_ID(state, entity_id) {
      state.current_entity_id = Number(entity_id)
      const entity = state.availableEntities.find(t => t.entity_id === state.current_entity_id)
      state.current_entity_name =  entity ? entity.name : 'Unknown'
      localStorage.setItem('current_entity_id', state.current_entity_id) // Save entity_id to localStorage
    },
    CLEAR_ENTITY_ID(state) {
      state.current_entity_id = null
      state.current_entity_name =  null
      localStorage.removeItem('current_entity_id') // Remove entity_id from localStorage
    },
    SET_ENTITY_IDS(state, availableEntities){
      state.availableEntities = availableEntities
      state.hasRequestedEntities = true

      const currentEntity = availableEntities.find(t => t.entity_id === Number(state.current_entity_id))

      if(currentEntity){
        // Update the name for the existing current entity
        state.current_entity_name = currentEntity.name
      } else if(state.availableEntities.length > 0){
        // Fallback to first entity if current doesn't exist
        state.current_entity_id = Number(state.availableEntities[0].entity_id)
        state.current_entity_name = state.availableEntities[0].name
        localStorage.setItem('current_entity_id', state.current_entity_id) // Save initial entity_id to localStorage
      }
    },
  },
  getters : {
    availableEntities: state => state.availableEntities,
    availableEntityIds: state => {
      const ids = [];
      state.availableEntities.forEach(entity => {
        ids.push(entity.entity_id); // Add the entity's own ID
        if (entity.descendants && entity.descendants.length > 0) {
          ids.push(...entity.descendants.map(descendant => descendant.entity_id)); // Add descendant IDs
        }
      });
      return ids;
    },
    hasRequestedEntities: state => state.hasRequestedEntities,
    current_entity_id: state => state.current_entity_id,
    current_entity_name: state => state.current_entity_name
  },
  actions: {
    async initializeEntities({dispatch}){
      try {
        await dispatch('fetchAvailableEntities');
      } catch (error) {
        console.error('Failed to initialize entities:', error);
      }
    },
    setEntity_id({ commit }, entity_id) {
      commit('SET_ENTITY_ID', entity_id)
    },
    clearEntity_id({ commit }) {
      commit('CLEAR_ENTITY_ID')
    },
    fetchAvailableEntities({ commit }) {
      if (pendingEntitiesRequest) return pendingEntitiesRequest
      const params = canAccessFeature(FEATURES.DATA_ENTITIES_ALL) ? {} : { include_descendants: true }
      pendingEntitiesRequest = axios.get('/api/appuserentities/', { params }).then(response => {
        commit('SET_ENTITY_IDS', response.data.sort((a, b) => a.name.localeCompare(b.name)))
        return response.data
      }).finally(() => {
        pendingEntitiesRequest = null
      })
      return pendingEntitiesRequest
    }
  }
}
